import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    _lineItemId: Yup.number().required(requiredMessage),
    itemId: Yup.number(),
    itemCorpid: Yup.string().nullable(),
    tariffNumber: Yup.string().max(48, "Max length allowed is 48.").nullable(),
    countryOrigin: Yup.string().max(2, "Max length allowed is 2.").nullable(),
    commodityGroupingCode: Yup.string().max(48, "Max length allowed is 48.").nullable(),
    usCustomsBindingRule: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    quotaCategory: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    quotaCategory1: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    quotaCategory2: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    quotaCategory3: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    quotaCategory4: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    quotaCategory5: Yup.string().max(30, "Max length allowed is 30.").nullable(),
    message: Yup.string().max(1000, "Max length allowed is 1000.").nullable(),
  })
}

export default makeValidationSchema
